import { PureAbility } from "@casl/ability";
import { ContainerModule } from "inversify";

import { AbilityService } from "./ability.service";
import { Ability_DIID, Ability_Service_DIID } from "./ability.type";

export const AbilityModule = new ContainerModule((bind) => {
    bind(Ability_DIID.symbol).toConstantValue(new PureAbility());
    bind(Ability_Service_DIID.symbol).to(AbilityService).inSingletonScope();
});
